import {createRouter, createWebHistory} from '@ionic/vue-router';
import {VersionService} from "@/services/version.service.js";
import DataService from "@/services/data.service.js";

const routes = [
    {
        path: '/',
        name: 'Welcome',
        component: () => import('@/views/Welcome.vue'),
    },
    {
        path: '/calculator',
        name: 'Calculator',
        component: () => import('@/views/Calculator.vue'),
    },
    {
        path: '/overview/:data',
        name: 'Overview',
        props: true,
        component: () => import('@/views/Overview.vue')
    },
    {
        path: '/old-version',
        name: 'OldVersion',
        component: () => import('@/views/OldVersion.vue'),
    },
    {
        path: '/old-data',
        name: 'OldData',
        component: () => import('@/views/OldData.vue'),
    },
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});

//comment out when local
router.beforeEach(async (to, from, next) => {
    // Check if is old version
    if (VersionService.isOldAppVersion()) {
        next({path: '/old-version'});
    }

    //check if data is provided
    if(!DataService.hasData() && to.name !== 'OldData') {
        next({path: '/old-data'});
    }

    if (typeof from.name == "undefined" && typeof to.redirectedFrom == "undefined") {
        next({path: '/'});
    } else {
        next();
    }
})

export default router;